export default "__VITE_ASSET__Ckg2Gqb___"